(function () {
  const header = () => {
    //const header = document.querySelector(".shopify-section-header-v2");
    const menu = document.querySelector(".list-menu-v2--inline");
    const menuLinks = document.querySelectorAll(".list-menu-v2-item");

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty("--ann-height", `${entry.intersectionRect.height}px`);
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });
    if (annBar) annBarObserver.observe(annBar);

    const megaMenus = document.querySelectorAll(".mega-menu");

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        if (link.classList.contains("list-menu-v2--megamenu")) {
          link.classList.add("list-menu-v2--megamenu-visible");

          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            const megaMenuPositionRight = megaMenu.getBoundingClientRect().right;
            const windowRight = window.innerWidth;
            if (megaMenuPositionRight > windowRight) {
              megaMenu.style.right = "0";
            }
            if (megaMenu == link.querySelector(".mega-menu")) {
              megaMenu.style.opacity = 0;
              megaMenu.style.display = "grid";
              setTimeout(() => {
                megaMenu.style.opacity = 1;
              }, 100);
            }
          });

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu-v2--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu-v2--megamenu-visible");
          });
        }
      });
      link.addEventListener("mouseleave", (e) => {
        if (link.classList.contains("list-menu-v2--megamenu")) {
          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            if (megaMenu == link.querySelector(".mega-menu")) {
              megaMenu.style.opacity = 0;
              setTimeout(() => {
                megaMenu.style.display = "none";
              }, 300);
            }
          });
        }
      });
      link.addEventListener("focus", (e) => {
        if (link.classList.contains("list-menu-v2--megamenu")) {
          link.classList.add("list-menu-v2--megamenu-visible");

          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            const megaMenuPositionRight = megaMenu.getBoundingClientRect().right;
            const windowRight = window.innerWidth;
            if (megaMenuPositionRight > windowRight) {
              megaMenu.style.right = "0";
            }
          });

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu-v2--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu-v2--megamenu-visible");
          });
        }
      });
    });
    menu.addEventListener("mouseleave", (e) => {
      if (!megaMenus) return;
      setTimeout(() => {
        megaMenus.forEach((megaMenu) => {
          megaMenu.style.right = "auto";
        });
      }, 500);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu-v2--megamenu-visible");
      });
    });
    menu.addEventListener("focusout", (e) => {
      if (!megaMenus) return;
      setTimeout(() => {
        megaMenus.forEach((megaMenu) => {
          megaMenu.style.right = "auto";
        });
      }, 500);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu-v2--megamenu-visible");
      });
    });

    const megaMenuTabs = () => {
      const ACTIVE_CLASS = "mega-menu__tab-wrapper--active";
      const TAB_WRAPPER_SELECTOR = ".mega-menu__tab-wrapper";

      // Get all tab wrapper elements
      const allTabWrappers = document.querySelectorAll(TAB_WRAPPER_SELECTOR);

      if (allTabWrappers.length === 0) {
        return; // Early return if no elements found
      }

      // Initialize: Find the first nested tab wrapper within children and activate it
      // This replicates: $(".mega-menu__tab-wrapper").children().find(".mega-menu__tab-wrapper").first().addClass(...)
      const nestedTabWrappers = [];
      allTabWrappers.forEach((tabWrapper) => {
        const children = Array.from(tabWrapper.children);
        children.forEach((child) => {
          const nested = child.querySelector(TAB_WRAPPER_SELECTOR);
          if (nested) {
            nestedTabWrappers.push(nested);
          }
        });
      });

      // Activate the first nested tab wrapper found
      if (nestedTabWrappers.length > 0) {
        nestedTabWrappers[0].classList.add(ACTIVE_CLASS);
      }

      // Helper function to handle tab activation
      const activateTab = (targetElement) => {
        if (!targetElement) return;

        // Remove active class from all tab wrappers
        allTabWrappers.forEach((tab) => {
          tab.classList.remove(ACTIVE_CLASS);
        });

        // Add active class to the target element
        targetElement.classList.add(ACTIVE_CLASS);
      };

      // Add event listeners to all tab wrappers
      allTabWrappers.forEach((tabWrapper) => {
        // Mouse enter event
        tabWrapper.addEventListener("mouseenter", (event) => {
          activateTab(event.currentTarget);
        });

        // Focus event
        tabWrapper.addEventListener("focus", (event) => {
          activateTab(event.currentTarget);
        });

        // Focus in event
        tabWrapper.addEventListener("focusin", (event) => {
          activateTab(event.currentTarget);
        });
      });
    };
    megaMenuTabs();

    const main = document.querySelector("main");
    if (
      main.querySelectorAll(".shopify-section")[0] &&
      main.querySelectorAll(".shopify-section")[0].classList.contains("section--has-overlay")
    ) {
    }

    const menuCloseBtn = document.querySelector(".header-v2__modal-close-button");
    const mobileMenuDrawer = document.querySelector("header-drawer-v2");
    menuCloseBtn.addEventListener("click", (e) => {
      mobileMenuDrawer.closeMenuDrawer(e);
    });
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();
})();
